import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import {
  AdminUsersFilter,
  AdminUsersTable,
  AdminUsersStatus,
  AdminUsersBalance,
} from "@/components/pages/admin-users";
import { SharedButtonIcon } from "@/components/shared";
import { AdminBalanceCard } from "@/components/layouts/admin";

import { PAGE_SIZE, SvgAttribute } from "@/shared/constants/constants";
import { SortFactory } from "@/shared/factory/sort";
import { SearchFactory } from "@/shared/factory/search";
import { SearchStatus, SearchType } from "@/shared/constants/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AdminUsersFilter,
    AdminUsersTable,
    AdminUsersStatus,
    AdminUsersBalance,
    SharedButtonIcon,
    AdminBalanceCard,
  },
  data() {
    return {
      isBalance: false,
      isStatus: false,
      sort: SortFactory(),
      search: SearchFactory(),
      usersRepo: this.$projectServices.usersRepo,
    };
  },
  computed: {
    inUserId(): number {
      const hostname = window.location.hostname;
      if (
        hostname.includes("uat.mex.broker") ||
        hostname.includes("localhost")
      ) {
        return 203; // UAT
      }
      return 204; // PROD
    },

    outUserId(): number {
      const hostname = window.location.hostname;
      if (
        hostname.includes("uat.mex.broker") ||
        hostname.includes("localhost")
      ) {
        return 204; // UAT
      }
      return 205; // PROD
    },

    displayedUserIndex(): number {
      return this.usersRepo.index;
    },

    displayedIcons(): SvgAttribute {
      return SVG;
    },

    isMoreShow(): boolean {
      return (
        this.sort.page * PAGE_SIZE < this.usersRepo.users.length &&
        !this.search.value
      );
    },

    isStatusShow(): boolean {
      return !!this.displayedUserIndex && this.isStatus;
    },

    isBalanceShow(): boolean {
      return !!this.displayedUserIndex && this.isBalance;
    },

    displayedUsersSize(): number {
      const { value, type, status } = this.search;
      let users = this.usersRepo.users;

      if (status !== SearchStatus.all) {
        if (status === SearchStatus.none) {
          users = users.filter(
            (user) => user.kyb_staus == null && user.kyc_status == null
          );
        } else {
          users = users.filter(
            (user) => user.kyb_staus === status || user.kyc_status === status
          );
        }
      }

      return users.filter((user) => {
        if (value) {
          switch (type) {
            case SearchType.all:
              return `${user.id} ${user.email} ${user.applicant_name ?? ""} ${
                user.applicant_surname ?? ""
              }`
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.id:
              return user.id
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.email:
              return user.email
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.fio:
              return `${user.applicant_name ?? ""} ${user.applicant_surname}`
                .toLowerCase()
                .includes(value.toLowerCase());
            default:
              return user;
          }
        }

        return user;
      }).length;
    },

    lastPage(): number {
      const page = Math.ceil(this.displayedUsersSize / PAGE_SIZE);
      if (page > 0 && this.sort.page > page) {
        this.goToPage(1);
      }
      return page;
    },
  },
  methods: {
    handleMore(): void {
      this.sort.page++;
    },

    goToPage(page: number): void {
      this.sort.page = page;
    },
  },
});
